module.exports = __webpack_public_path__ + "img/sub.55d4a507.png";